import UnexpectedStockOutflow from '../../domain/UnexpectedStockOutflow'

export const getByProduct = async (repository, { idProducto, fechaInicio, fechaFin }) => {
  try {
    if (!idProducto) {
      throw new Error('El ID del producto es requerido')
    }

    if (!fechaInicio || !fechaFin) {
      throw new Error('El rango de fechas es requerido')
    }

    const outflows = await repository.findByProduct(idProducto, fechaInicio, fechaFin)
    return outflows
  } catch (error) {
    throw new Error(error.message || 'Error al obtener las salidas inesperadas del producto')
  }
} 